import { v4 as uuid } from "uuid";

import { IGroupSpaceResource } from "../../group-spaces";
import { ILearnerLink } from "../../topics";
import { createApiMutationHook, IApiMutationFunction, RelationalValue } from "../../utils";

export interface IGroupWorkCreateMutationParameters {
    uuid?: string;
    groupSpace: RelationalValue<IGroupSpaceResource>;
    links: ILearnerLink[];
    comment: string;
    // @type Array<iri-reference>
    mediaSecured: string[];
}

export type IGroupWorkCreateMutationResult = IGroupSpaceResource;

export const groupWorkCreateMutation: IApiMutationFunction<IGroupWorkCreateMutationParameters> = ({
    uuid: providedUuid,
    groupSpace,
    links,
    comment,
    mediaSecured,
}) => {
    return {
        method: "POST",
        url: "group_works",
        data: {
            uuid: providedUuid ?? uuid(),
            groupSpace,
            links,
            comment,
            mediaSecured,
        },
    };
};

export const useGroupWorkCreateMutation = createApiMutationHook<
    IGroupWorkCreateMutationParameters,
    IGroupWorkCreateMutationResult
>(groupWorkCreateMutation);
